export const FETCH_PUBLIC_DICTIONARY_REQUEST = 'FETCH_EDUCATION_GRADE_REQUEST'
export const FETCH_PUBLIC_DICTIONARY_SUCCESS = 'FETCH_EDUCATION_GRADE_SUCCESS'
export const FETCH_PUBLIC_DICTIONARY_FAILURE = 'FETCH_EDUCATION_GRADE_FAILURE'
